export interface LayoutConfirmationRequest {
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

class LayoutConfirmationStore {
  private current: LayoutConfirmationRequest | null = null;
  private listeners = new Set<() => void>();

  getPending(): LayoutConfirmationRequest | null {
    return this.current;
  }

  request(req: LayoutConfirmationRequest) {
    // Apply immediately — unsaved-changes guard prompts only when leaving the page.
    req.onConfirm();
  }

  confirm() {
    if (this.current) {
      const apply = this.current.onConfirm;
      this.current = null;
      this.notify();
      apply();
    }
  }

  cancel() {
    if (this.current) {
      const onCancel = this.current.onCancel;
      this.current = null;
      this.notify();
      onCancel?.();
    }
  }

  subscribe(listener: () => void) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify() {
    this.listeners.forEach((l) => l());
  }
}

export const layoutConfirmationStore = new LayoutConfirmationStore();
export const requestLayoutConfirmation = (req: LayoutConfirmationRequest) =>
  layoutConfirmationStore.request(req);
